<template>
  <div>
    <div class="timeContainer">
      <div style="marginLeft: 15px; paddingTop: 5px">{{ $t('totalFriends') }}: <span>{{friendCount}}</span></div>
      <el-select
        v-model="option"
        v-bind:placeholder="$t('week')"
        value=""
        @change="updateFilter"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="$t(item.label)"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <canvas id="myChart" width="400" height="200"> </canvas>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
// import { DataSet, Network } from "vis/index-network";
import Chart from "chart.js";
import { Tooltip } from "element-ui";

export default {
  name: "InviteGraph",

  data() {
    return {
      myChart1: null,
      inviteData: [],
      inviteLabel: [],
      inviteMax: 0,
      option: "week",
      options: [
        {
          value: "week",
          label: "weekly",
        },
        {
          value: "month",
          label: "monthly",
        },
      ],
    };
  },
  mounted() {
    // this.createInviteChart();
    // this.fetchInviteHistory();
  },
  computed: mapState({
    inviteHistoryData: (state) => state.addresses.inviteHistoryData,
    friendCount: (state) => state.addresses.friendCount,
    // userDetails: (state) => state.auth.userDetails,
  }),
  watch: {
    inviteHistoryData: function (newVal, oldVal) {
      this.inviteData = [];
      this.inviteLabel = [];
      this.inviteHistoryData.counts.map((r, i) => {
        this.inviteData.push(r.counts);
      });
      this.inviteHistoryData.daliy.map((r, i) => {
        this.inviteLabel.push(r.slice(0, -3));
      });

      if (this.option === "week") {
        this.inviteData.splice(0, this.inviteData.length - 7);
        this.inviteLabel.splice(0, this.inviteLabel.length - 7);
      } else if (this.options === "month") {
      }
      this.inviteMax = 0;
      this.inviteHistoryData.counts.map((r, i) => {
        if (r.counts >= this.inviteMax) {
          this.inviteMax += 5;
        }
      });

      if (this.myChart1) {
        this.myChart1.destroy();
      }
      this.createInviteChart();
    },
  },
  methods: {
    ...mapActions("addresses", ["fetchInviteHistory"]),
    updateFilter() {
      this.fetchInviteHistory();
    },
    createInviteChart() {
      var ctx = document.getElementById("myChart").getContext("2d");
      this.myChart1 = new Chart(ctx, {
        type: "line",
        data: {
          labels: this.inviteLabel,
          datasets: [
            {
              label: this.$t("numberInvites"),
              data: this.inviteData,
              backgroundColor: ["rgba(255, 159, 64, 0.2)"],
              borderColor: ["rgba(255, 159, 64, 1)"],
              borderWidth: 1,
            },
          ],
        },
        options: {
          scales: {
            yAxes: [
              {
                // gridLines: {
                //   display: false,
                // },
                ticks: {
                  max: this.inviteMax,
                  stepSize: 1,
                  beginAtZero: true,
                },
              },
            ],

          },
        },
      });
    },
  },
};
</script>

<style lang="less" scope>
.timeContainer {
  .el-select {
    width: 12%;
    cursor: pointer;
    outline: none;
    position: absolute;
    right: 30px;
    top: 50px;
    /deep/.el-input__inner {
      border: 0;
      background-color: transparent;
    }
  }
}

@media only screen and (max-width: 787px) {
  .timeContainer {
    .el-select {
      width: 25%;
      cursor: pointer;
      outline: none;
      position: absolute;
      right: 30px;
      top: 50px;
      /deep/.el-input__inner {
        font-size: 10px;
        border: 0;
        background-color: transparent;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/invitegraph.vue